function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPen = function SvgPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 56012"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 56005"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26092",
    d: "M9.4 21.6a.822.822 0 0 1-.805-.966l.378-2.119a1.51 1.51 0 0 1 .357-.737l5.641-6.364a1.513 1.513 0 0 1 2.116-.139l.654.567a1.509 1.509 0 0 1 .152 2.127l-5.615 6.481a1.512 1.512 0 0 1-.655.441l-1.953.664a.828.828 0 0 1-.27.045zm6.7-9.826a.641.641 0 0 0-.481.215L9.98 18.353a.646.646 0 0 0-.152.314l-.365 2.043 1.881-.64a.644.644 0 0 0 .28-.188L17.24 13.4a.643.643 0 0 0-.065-.905l-.654-.567a.638.638 0 0 0-.421-.154z",
    style: {
      fill: "#858baf",
      stroke: "#858baf",
      strokeWidth: ".7px"
    },
    transform: "translate(-6.084 -8.558)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 29710",
    transform: "rotate(-49.1 8.914 -6.224)",
    style: {
      fill: "#858baf",
      stroke: "#858baf",
      strokeWidth: ".7px"
    },
    d: "M0 0h.866v3.027H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26093",
    d: "M31.674 82.366H21.365a.433.433 0 1 1 0-.866h10.309a.433.433 0 1 1 0 .866z",
    transform: "translate(-16.607 -66.718)",
    style: {
      fill: "#858baf",
      stroke: "#858baf",
      strokeWidth: ".7px"
    }
  }))));
};

export default SvgPen;